export interface PullRequestMention {
    title: string;
    id: number;
    url: string;
}